module.exports = __webpack_public_path__ + "img/ass14.9f5994f2.jpg";